import { arrayOf, bool, number, object, shape } from 'prop-types';
import Header from '../../Header/Header';
import BoxSubscriptionPanel from '../../Panels/BoxSubscriptionPanel/BoxSubscriptionPanel';
import CustomizePanel from '../../Panels/CustomizePanel/CustomizePanel';
import NinetyDaysPanel from '../../Panels/NinetyDaysPanel/NinetyDaysPanel';
import NoSubcriptions from '../NoSubscriptions/NoSubscriptions';
import * as styles from './ExpiredUserEmptyState.module.scss';

const ExpiredUserEmptyState = ({
  isExpired,
  isClubTier = false,
  isCustomizeOpen,
  isCustomizeShown,
  showGrowthReactivatePopUp,
  sysdata,
  subscriptions,
  ninetyDaysPriceTotal,
  isShoppingClubUser,
  userBoxSubscriptions,
  boxSubscriptionProducts = {},
  boxSubscriptionSaleInfo = {},
  userExistingCart,
}) => (
  <div data-testid="expired-user-empty-state-container" className={styles.container}>
    {/* Display Customizations panel if is a CLUB tier user */}
    {/* and customize status is close */}
    {/* Also if it's a guest user customize status is open */}
    {/* THEN display the "Ship Every 3 Months" section */}
    {/* only display the NoSubscriptions screen */}
    <Header
      hideContent={(isExpired && isCustomizeOpen) || (isClubTier && !isCustomizeOpen)}
      isProductSubscription
    />
    {userBoxSubscriptions.map((userBoxSubscription) => (
      <BoxSubscriptionPanel
        key={userBoxSubscription.id}
        boxSubscription={userBoxSubscription}
        sysdata={sysdata}
        products={boxSubscriptionProducts[userBoxSubscription.id] || []}
        customizeSaleInfo={boxSubscriptionSaleInfo[userBoxSubscription.id]}
        userExistingCart={userExistingCart}
      />
    ))}
    {isCustomizeOpen && isCustomizeShown && (
      <CustomizePanel sysdata={sysdata} showGrowthReactivatePopUp={showGrowthReactivatePopUp} />
    )}
    {!isCustomizeOpen && isClubTier && !isShoppingClubUser && (
      <CustomizePanel sysdata={sysdata} showGrowthReactivatePopUp={showGrowthReactivatePopUp} />
    )}
    {subscriptions.length > 0 ? (
      <NinetyDaysPanel
        subscriptions={subscriptions}
        sysdata={sysdata}
        subTotal={ninetyDaysPriceTotal}
      />
    ) : (
      <>
        <div className={styles.header}>
          <h1>Subscriptions</h1>
        </div>
        <NoSubcriptions ctaURL="/shop" />
      </>
    )}
  </div>
);

ExpiredUserEmptyState.propTypes = {
  isExpired: bool.isRequired,
  isClubTier: bool,
  isCustomizeOpen: bool.isRequired,
  isCustomizeShown: bool.isRequired,
  showGrowthReactivatePopUp: bool.isRequired,
  sysdata: shape({}).isRequired,
  subscriptions: arrayOf(object).isRequired,
  ninetyDaysPriceTotal: number.isRequired,
  isShoppingClubUser: bool,
  userBoxSubscriptions: arrayOf(object),
  boxSubscriptionProducts: shape({}),
  boxSubscriptionSaleInfo: shape({}),
  userExistingCart: shape({}),
};

export default ExpiredUserEmptyState;
